// src/screens/student/studycalendar/StudyCalendar.js
import React, { useContext, useEffect, useState } from 'react';
import '../../../assets/css/student/studycalendar/StudyCalendar.css';
import StudentLayout from '../../../layouts/student/studentlayout/StudentLayout';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { WhatsappIcon, WhatsappShareButton } from 'react-share';
import { FaCopy } from "react-icons/fa";
import Swal from 'sweetalert2';


const StudyCalendar = () => {

  const navigate = useNavigate();

  const { baseUrl, loggedInStudent, storeSelectedSessionForVideocall } = useContext(AppContext);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [groups, setGroups] = useState([]);
  const [createoredit, setCreateoredit] = useState('create');




  // Dummy events data
  const [sessionTitle, setSessionTitle] = useState("");
  const [chstudygroup_id, setChstudyGroup_id] = useState();
  const [date, setDate] = useState("");
  const [eventType, setEventType] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [joinLink, setJoinLink] = useState("");
  const [chmentor_id, setChmentor_id] = useState();
  const [chstudent_id, setChstudent_id] = useState();

  const [sessionid, setSessionid] = useState();


  const viewAllStudySessions = () => {
    axios.post(`${baseUrl}/student/studySessions/viewAllStudySessions`)
      .then((response) => {
        console.log(response.data);
        setSessions(response.data.studySessions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllStudyGroups = () => {
    const formData = new FormData();
    formData.append("chstudent_id", loggedInStudent.id);

    axios.post(`${baseUrl}/student/studygroup/viewAllStudyGroups`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then((response) => {
        console.log(response.data);
        setGroups(response.data.studygroups);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const createStudySessions = () => {
    const formData = new FormData();
    formData.append("sessionTitle", sessionTitle);
    formData.append("chstudygroup_id", chstudygroup_id);
    formData.append("date", date);
    formData.append("eventType", eventType);
    formData.append("startTime", startTime);
    formData.append("endTime", endTime);
    formData.append("joinLink", joinLink);
    formData.append("chstudent_id", loggedInStudent.id);

    axios.post(`${baseUrl}/student/studySessions/createStudySession`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
      .then((response) => {
        console.log(response.data);
        setShowCreateModal(false);
        viewAllStudySessions();
      })
      .catch((error) => {
        console.log(error);
      });

  };
  const updateStudySessions = () => {
    const formData = new FormData();
    formData.append("id", sessionid);
    formData.append("sessionTitle", sessionTitle);
    formData.append("chstudygroup_id", chstudygroup_id);
    formData.append("date", date);
    formData.append("eventType", eventType);
    formData.append("startTime", startTime);
    formData.append("endTime", endTime);
    formData.append("joinLink", joinLink);
    formData.append("chstudent_id", loggedInStudent.id);

    axios.post(`${baseUrl}/student/studySessions/updateStudySession`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
      .then((response) => {
        console.log(response.data);
        setShowCreateModal(false);
        viewAllStudySessions();
      })
      .catch((error) => {
        console.log(error);
      });

  };

  const deleteStudySessions = (sessionId) => {
    axios.post(`${baseUrl}/student/studySessions/deleteStudySession`, { id: sessionId })
      .then((response) => {
        console.log(response.data);
        viewAllStudySessions();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [newEvent, setNewEvent] = useState({
    title: '',
    group: '',
    date: '',
    startTime: '',
    endTime: '',
    type: 'study-group',
    joinLink: ''
  });


  const handleToday = () => {
    setCurrentDate(new Date());
    setSelectedDate(new Date());
  };

  const handleCreateEvent = (e) => {
    e.preventDefault();
    console.log('Creating event:', newEvent);
    setShowCreateModal(false);
    setNewEvent({
      title: '',
      group: '',
      date: '',
      startTime: '',
      endTime: '',
      type: 'study-group',
      joinLink: ''
    });
  };

  useEffect(() => {
    console.log("HELLO WORLD");
    viewAllStudySessions();
    viewAllStudyGroups();
  }, [loggedInStudent]);
  return (
    <StudentLayout>
      <div className="study-calendar">
        {/* Header */}
        <div className="page-header">
          <div className="page-title-section">
            <div className="page-title-icon">📅</div>
            <div>
              <h1 className="page-title">Study Calendar</h1>
              <p className="page-description">Schedule and manage your study sessions</p>
            </div>
          </div>
          <div className="header-actions">
            <button className="btn btn-outline" onClick={handleToday}>
              Today
            </button>
            <button
              className="btn btn-primary"
              onClick={() => setShowCreateModal(true)}
            >
              <span>➕</span>
              Schedule Session
            </button>
          </div>
        </div>

        {/* Stats - Only this month & upcoming */}
        <div className="calendar-stats">
          <div className="stat-card">
            <div className="stat-icon">📅</div>
            <div>
              <div className="stat-value">12</div>
              <div className="stat-label">This Month</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🎯</div>
            <div>
              <div className="stat-value">5</div>
              <div className="stat-label">Upcoming</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">✅</div>
            <div>
              <div className="stat-value">8</div>
              <div className="stat-label">Completed</div>
            </div>
          </div>
        </div>


        <div className='mt-5'>
          {/* Events Sidebar */}
          <div className="events-sidebar">
            <div className="sidebar-header">
              <h3>
                {selectedDate.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </h3>
            </div>

            <div className="events-list">
              {sessions.length === 0 ? (
                <div className="no-events">
                  <div className="no-events-icon">📭</div>
                  <p>No events scheduled</p>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => setShowCreateModal(true)}
                  >
                    Schedule Session
                  </button>
                </div>
              ) : (
                sessions.map(event => (
                  <div key={event.id} className={`event-card col-lg-5 mx-4 event-${event.eventType}`}>
                    <div className="event-type-indicator"></div>
                    <div className="event-content">
                      <h4 className="event-title">{event.sessionTitle}</h4>
                      <div className="event-group">📚 {event.chstudygroup?.groupName}</div>
                      <div className="event-time">📅 {event.date}</div>
                      <div className="event-time">🕐 {event.startTime} to {event.endTime}</div>
                      <div className="event-footer">
                        <span className="event-attendees">👥 {event.attendees} attending</span>
                        <div className="event-actions">

                          <button className="btn-icon btn-primary" title="Join Class"
                            onClick={async () => {
                              try {
                                await navigator.clipboard.writeText(`https://circlehub.btsportfolio2026.com/student-groupcall/${event.sessionTitle}`.replaceAll(" ", "%20"));
                                Swal.fire({
                                  title: "Amazing!",
                                  text: "Meeting link copied for sharing.",
                                  icon: "success"
                                });
                              } catch (err) {
                                console.error('Failed to copy: ', err);
                              }
                              // navigate();
                            }}

                          ><FaCopy />
                          </button>
                          <button className="btn-icon btn-primary" title="Join Class"
                            onClick={() => {
                              storeSelectedSessionForVideocall(event);
                              navigate(`/student-groupcall/${event.sessionTitle}`);
                            }}

                          >Join</button>
                          <button className="btn-icon" title="Edit"
                            onClick={() => {
                              setCreateoredit('edit');
                              setShowCreateModal(true);
                              setSessionid(event.id);
                              setSessionTitle(event.sessionTitle);
                              setChstudyGroup_id(event.chstudygroup?.id);
                              setDate(event.date);
                              setEventType(event.eventType);
                              setStartTime(event.startTime);
                              setEndTime(event.endTime);
                              setJoinLink(event.joinLink);

                            }}

                          >✏️</button>
                          <button className="btn-icon" title="Delete"
                            onClick={() => deleteStudySessions(event.id)}
                          >🗑️</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  // <div key={event.id} className={`event-card event-${event.type}`}>
                  //   <div className="event-type-indicator"></div>
                  //   <div className="event-content">
                  //     <h4 className="event-title">{event.title}</h4>
                  //     <div className="event-group">📚 {event.group}</div>
                  //     <div className="event-time">🕐 {event.date}</div>
                  //     <div className="event-time">🕐 {event.time}</div>
                  //     <div className="event-footer">
                  //       <span className="event-attendees">👥 {event.attendees} attending</span>
                  //       <div className="event-actions">
                  //         <button className="btn-icon" title="Edit">✏️</button>
                  //         <button className="btn-icon" title="Delete">🗑️</button>
                  //       </div>
                  //     </div>
                  //   </div>
                  // </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* Create Event Modal */}
        {showCreateModal && (
          <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Schedule Study Session</h2>
                <button
                  className="modal-close"
                  onClick={() => setShowCreateModal(false)}
                >
                  ✕
                </button>
              </div>

              <form onSubmit={(e) => {
                e.preventDefault();
                createoredit === 'create' ? createStudySessions() : updateStudySessions();
              }} className="event-form">
                <div className="form-group">
                  <label>Session Title *</label>
                  <input
                    type="text"
                    placeholder="e.g., React Hooks Study Session"
                    value={sessionTitle}
                    onChange={(e) => setSessionTitle(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Study Group *</label>
                  <select
                    value={chstudygroup_id}
                    onChange={(e) => setChstudyGroup_id(e.target.value)}
                    required
                  >
                    <option value="">Select Group</option>
                    {groups.map(group => (
                      <option key={group.id} value={group.id}>
                        {group.groupName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Date *</label>
                    <input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}

                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Event Type *</label>
                    <select
                      value={eventType}
                      onChange={(e) => setEventType(e.target.value)}
                      required
                    >
                      <option value="study-group">Study Group</option>
                      <option value="live-session">Live Session</option>
                      <option value="practice">Practice</option>
                      <option value="quiz">Quiz/Test</option>
                      <option value="deadline">Deadline</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Start Time *</label>
                    <input
                      type="time"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>End Time *</label>
                    <input
                      type="time"
                      value={endTime}
                      onChange={(e) => setEndTime(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* 🌟 New Join Link field added */}
                <div className="form-group">
                  <label>Join Link</label>
                  <input
                    type="url"
                    placeholder="e.g., https://zoom.us/j/123456789"
                    value={joinLink}
                    onChange={(e) => setJoinLink(e.target.value)}
                  />
                </div>

                <div className="modal-actions">
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={() => setShowCreateModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {createoredit === 'create' ? "Schedule Session" : "Update Session"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </StudentLayout>
  );
};

export default StudyCalendar;
